import BookingPage from '@/pages/admin/BookingPage';
import { createFileRoute } from '@tanstack/react-router';

type BookingSearch = {
  page?: number;
  memberName?: string;
  phoneNumber?: string;
};

export const Route = createFileRoute('/admin/booking/')({
  component: () => <BookingPage />,

  validateSearch: (search: Record<string, unknown>): BookingSearch => {
    return {
      page: Number(search.page) || 1,
      memberName: search.memberName as string | undefined,
      phoneNumber: search.phoneNumber as string | undefined,
    };
  },
});
